import { tgxApi } from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import { getFileName, serialize } from "../../../helpers/utils/Utils";
import { downloadFile } from "../../../helpers/utils/FileUtils";

export const billReleaseApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        
        searchBillReleases: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/ajax/bill-releases?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['billReleases'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

 

        createBillRelease: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/ajax/create-bill-release`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['billReleases'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Created", "Bill-Release")
            },
        }),
        getBillReleaseById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-bill-release-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['billReleaseById'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        updateBillRelease: build.mutation({
            query: ({ id, requestBody }) => {
                return {
                    url: `/ajax/update-bill-release/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['billReleases', 'billReleaseById', 'userAuditableInfo'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Bill-Release")
            },
        }),

        exportBillReleaseData: build.query({
            query: (query) => {
                return {
                    url: `/export/billRelease`,
                    method: 'POST',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("billRelease"))
                        return { success: true };
                    },
                };
            },
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),
        deleteBillReleaseById: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/delete-bill-release/${id}`,
                    method: 'DELETE',
                    headers: getAuthorizationHeader()
                };
            },
            invalidatesTags: ['billReleases'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Deleted", "Bill Releases");
            },
        }),
    }),
});


export const {
    useCreateBillReleaseMutation,
    useGetBillReleaseByIdQuery,
    useUpdateBillReleaseMutation,
    useSearchBillReleasesQuery,
    useLazyExportBillReleaseDataQuery,
    useDeleteBillReleaseByIdMutation
} = billReleaseApi;